export default "__VITE_ASSET__CrRbPAt0__"